import useImportNameById from 'flow-doctor-lib/hooks/useImportNameById';
import useWorkflowNameById from 'flow-doctor-lib/hooks/useWorkflowNameById';
const useNameForInListType = ({
  portalId,
  metadata
}) => {
  const {
    data: importNameData,
    loading: importNameLoading,
    error: importNameError
  } = useImportNameById({
    portalId,
    importId: metadata && metadata.id
  }, {
    skip: !metadata || metadata.inListType !== 'IMPORT'
  });
  const {
    data: workflowData,
    loading: workflowDataLoading,
    error: workflowDataError
  } = useWorkflowNameById({
    portalId,
    workflowId: metadata && metadata.id
  }, {
    skip: !metadata || metadata.inListType === 'IMPORT'
  });
  return {
    data: importNameData || workflowData && workflowData.name,
    loading: importNameLoading || workflowDataLoading,
    error: importNameError || workflowDataError
  };
};
export default useNameForInListType;